module.exports = __webpack_public_path__ + "img/PhotoChromic_10.94380eb2.png";